/* React hooks */
import {useEffect, useState} from "react";
/* Routing */
import {useLocation, useParams} from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import FormUserInfos from "../../../forms/admin/FormUserInfos";
import Header from "../../../components/common/Header";
import {getAdminUserInfos} from "../../../api/admin/userReq";
import useAuth from "../../../hooks/useAuth";
import {safeJwtDecode} from "../../../helper/jwtHelper";
import {getUser} from "../../../api/pro/userReq";
import {capitalize} from "../../../helper/tools";
import Icon from "../../../components/common/Icon";


export default function ViewUserInfos() {
    const { id } = useParams();
    const { userInfos, setUserInfos } = useData();
    const { auth } = useAuth();
    const token = auth.token;
    const decodedToken = safeJwtDecode(token);
    const [showModal, setShowModal] = useState(false);
    const { pathname } = useLocation();

    const apiUserInfos = async () => {
        let response;
        if (pathname.includes("utilisateurs")) {
            response = await getAdminUserInfos(token, id)
        } else if (pathname.includes("collaborateurs") || pathname.includes("profil")) {
            if (pathname.includes("profil")) {
                response = await getUser(token, decodedToken?.userId)
            } else {
                response = await getUser(token, id)
            }
        }
        setUserInfos(response)
    };

    useEffect(() => {
        if (userInfos?.length < 1) {
            apiUserInfos()
        }
    }, [ userInfos ]);

    const handleUserForm = (e) => {
        e.preventDefault()
        setShowModal(true)
    };

    return (
        <main>
            <>
                <Header parent={pathname.includes("collaborateurs") ? "Collaborateurs" :
                    pathname.includes("profil") ? "Tableau de bord" : "Utilisateurs"}
                        location={(id != 0)
                            ? `Modification d'un ${pathname.includes('utilisateurs') ? 'utilisateur ' : 'collaborateur '}`
                            : "Ajout d'un utilisateur "}
                        locationComp={`${capitalize(userInfos?.lastName)} ${capitalize(userInfos?.firstName)}`}
                        slug={pathname.includes("collaborateurs") ? "/agence/collaborateurs" : pathname.includes("profil") ? "/" : "/admin/utilisateurs"}
                />
                {showModal &&
                    <div className="modal user-infos">
                        <FormUserInfos apiUserInfos={apiUserInfos} setShowModal={setShowModal}
                                       legend={`Modification ${pathname.includes("utilisateurs") ? "de l'utilisateur" : pathname.includes('profil') ? "du profil" : "du collaborateur"}`}
                                       workerId={id}/>
                    </div>
                }
                <fieldset>
                    <Icon source="fa fa-user" span={`${capitalize(userInfos?.lastName)} ${capitalize(userInfos?.firstName)}`}/>
                    <div className="form-input">
                        <label>Civilité : </label>
                        <span>{userInfos?.civility === "MME" ? "Madame" : "Monsieur"}</span>
                    </div>
                    <div className="form-input">
                        <label>Nom : </label>
                        <span>{capitalize(userInfos?.lastName)}</span>
                    </div>
                    <div className="form-input">
                        <label>Prénom : </label>
                        <span>{capitalize(userInfos?.firstName)}</span>
                    </div>
                    <div className="form-input">
                        <label>Fonction : </label>
                        <span>{userInfos?.occupation}</span>
                    </div>
                    <div className="form-input">
                        <label>Tél. fixe : </label>
                        <span>{userInfos?.fixedPhoneNumber}</span>
                    </div>
                    <div className="form-input">
                        <label>Tél. mobile : </label>
                        <span>{userInfos?.mobilePhoneNumber}</span>
                    </div>
                    <div className="form-input">
                        <label>Email : </label>
                        <span>{userInfos?.email}</span>
                    </div>
                    <div className="form-input">
                        <label>Identifiant : </label>
                        <span>{userInfos?.username}</span>
                    </div>
                    {(pathname.includes("collaborateurs") || pathname.includes("admin")) &&
                        <div className="form-input">
                            <label>Gestion des devis types : </label>
                            <span>{userInfos?.estimate == true ? "Oui" : "Non"}</span>
                        </div>
                    }
                    <div className="buttons-container">
                        <button type="button" className="red-button" onClick={handleUserForm}>
                            <i className="fa fa-pen-to-square"></i>
                            <span>Modifier les informations</span>
                        </button>
                    </div>
                </fieldset>
            </>
        </main>
    )
}